import { Pipe, PipeTransform } from '@angular/core';
import { getFileExtensionColor } from '@shared/functions/utils.type';

@Pipe({ name: 'fileExtensionColor' })
export class FileExtensionColorPipe implements PipeTransform {

  transform(fileUrl: string): string {
    return getFileExtensionColor(fileUrl);
  }

}
